import { AUOOptions } from "../../../Forms/Types/AUOOptions";

import { FullFormState } from "./FullFormState";

export const getAuoOptions = (state: FullFormState): Partial<AUOOptions> => ({
    abonId: state.settings.abonId,
    userId: state.settings.userId,
    orgId: state.settings.orgId,
});
